import React, { useState } from 'react'
import Modal from "../../shared/modal"
import Revisions from "../../shared/revisions"
import DatePicker from "react-datepicker"
import { format } from "date-fns"
import { useMobileRecordApi } from "../../../contexts/mobileRecordContext"
import DropdownValue from "./dropdownValue"

const EditEntryInput = ({ field, valueString, value, setValue }) => {
  const updateCoordinate = (index, newValue) => {
    setValue(prevValue => {
      return prevValue.map((coord, i) => i === index ? parseFloat(newValue) : coord)
    })
  }

  switch (field.data_type) {
    case 'text_input':
    case 'string':
      return (
        <textarea
          className="resize max-w-full w-full"
          value={value}
          onChange={e => setValue(e.target.value)}
        />
      )
    case 'geo_json':
      return (
        <>
          <input
            type="number"
            step="any"
            value={value[0]}
            onChange={e => updateCoordinate(0, e.target.value)}

            className="block w-full p-1 text-xs text-gray-700 appearance-none focus:outline-none border border-gray-200 focus:shadow-inner m-0 rounded"
          />
          <input
            type="number"
            step="any"
            value={value[1]}
            onChange={e => updateCoordinate(1, e.target.value)}

            className="block w-full p-1 text-xs text-gray-700 appearance-none focus:outline-none border border-gray-200 focus:shadow-inner m-0 rounded"
          />
        </>
      )
    case 'number':
      return (
        <input
          type="number"
          step="any"
          value={value}
          onChange={e => setValue(e.target.value)}
          className="block w-full p-1 text-xs text-gray-700 appearance-none focus:outline-none border border-gray-200 focus:shadow-inner m-0 rounded"
        />
      )
    case 'date_time': {
      // Convert the string value to a Date object for the DatePicker component
      const parsedValue = value ? new Date(value) : null
      return (
        <DatePicker
          className="block w-full p-1 text-xs text-gray-700 appearance-none focus:outline-none border border-gray-200 focus:shadow-inner m-0 rounded z-1000"
          selected={parsedValue}
          onChange={(date) => {
            setValue(format(date, 'yyyy-MM-dd'))
          }}
        />
      )
    }
    case 'dropdown': {
      return <DropdownValue field={field} value={value} callback={setValue} />
    }
    default:
      return <div>{valueString}</div>
  }
}

const EditEntryValueModel = ({ closeModal, entry, field, map, valueString }) => {
  const { updateEntry } = useMobileRecordApi()
  const [value, setValue] = useState(entry?.value ? entry.value : '')

  const submitEntry = (newValue) => {
    updateEntry({ ...entry, value: newValue }, map)
    closeModal()
  }

  return (
    <Modal closeModal={closeModal} heading={field.label} onSave={() => submitEntry(value)}>
      <div className='w-full flex flex-col lg:flex-row lg:justify-between gap-y-4 lg:gap-y-0 lg:gap-x-4'>
        <div className='w-full max-w-[80%] relative'>
          <EditEntryInput field={field} valueString={valueString} value={value} setValue={setValue} />
        </div>
        <div className='w-full'>
          {entry.versions ? <Revisions formEntry={entry} /> : <></>}
        </div>
      </div>
    </Modal>
  )
}

export default EditEntryValueModel
